import React from 'react';
import { MiniApp } from '@/types/miniApp';
import { useCTraderDeepLink } from '@/hooks/useCTraderDeepLink';
import { useMiniAppSession } from '@/hooks/useMiniAppSession';
import { MiniAppIcon } from './MiniAppIcon';

interface MiniAppCardProps {
  app: MiniApp;
}

export const MiniAppCard: React.FC<MiniAppCardProps> = ({ app }) => {
  const { openCTrader } = useCTraderDeepLink();
  const { hasValidSession, openApp } = useMiniAppSession(app.id);

  const handleOpen = () => {
    if (app.useDeepLink) {
      openCTrader();
    } else {
      openApp(app.url);
    }
  };

  return (
    <MiniAppIcon 
      app={app} 
      hasValidSession={hasValidSession} 
      onClick={handleOpen} 
    />
  );
};
